import React from "react";
import { useState, useEffect } from "react";
import { t } from "../../Helper";
import { useSelector } from "react-redux";

const OfferingTypeInfo = ({ onChange }) => {

  const [weOffer, setWeOffer] = useState("We offer ");
  const [productsOnly, setProductsOnly] = useState("Products Only");
  const [servicesOnly, setServicesOnly] = useState("Services Only");
  const [both, setBoth] = useState("Both : Product & Services");


  const { preferredLanguage, currentLanguage } = useSelector(
    (state) => state.settings
  );

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await t(
          weOffer,
          currentLanguage,
          preferredLanguage
        );
        setWeOffer(fetchedData);

        const fetchedData2 = await t(
          productsOnly,
          currentLanguage,
          preferredLanguage
        );
        setProductsOnly(fetchedData2);

        const fetchedData3 = await t(
          servicesOnly,
          currentLanguage,
          preferredLanguage
        );
        setServicesOnly(fetchedData3);

        const fetchedData4 = await t(
          both,
          currentLanguage,
          preferredLanguage
        );
        setBoth(fetchedData4);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [preferredLanguage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };



  return (
    <>
      <div className="col-12">
        <label className="form-label section-title">{weOffer}</label>
        <div className="row gx-2 gy-2">
          <div className="col-6 col-sm-4 col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                onChange={handleChange}
                id="pageHome"
                value="products"
                name="offering_type"
                required
              />
              <label className="form-check-label small" htmlFor="pageHome">
                {productsOnly}
              </label>
            </div>
          </div>
          <div className="col-6 col-sm-4 col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                onChange={handleChange}
                id="pageHome"
                value="services"
                name="offering_type"
                required
              />
              <label className="form-check-label small" htmlFor="pageAbout">
                {servicesOnly}
              </label>
            </div>
          </div>
          <div className="col-6 col-sm-4 col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                onChange={handleChange}
                id="pageHome"
                value="both"
                name="offering_type"
                required
              />
              <label className="form-check-label small" htmlFor="pageContact">
                {both}
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingTypeInfo;
